import React from "react";
import { Container, Typography } from "@mui/material";
const NotFound = (props) => {
    return (
        <Container style={{  height:'100vh', textAlign: "center", marginTop: "50px" }}>
            <Typography variant="h1">404 - Page Not Found</Typography>
            <Typography variant="body1" style={{ margin: "20px 0" }}>
                The page you are looking for does not exist.
            </Typography>
        </Container>
    );
};
NotFound.propTypes = {

};

export default NotFound;
